//
//
//
//
//
//

import InterfaceOne from './ui/InterfaceOne.vue';
import InterfaceTwo from './ui/InterfaceTwo.vue';
export default {
  name: 'Goods',
  components: {
    InterfaceOne: InterfaceOne,
    InterfaceTwo: InterfaceTwo
  },
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // 商品展示类型
    goodsShowType: function goodsShowType() {
      switch (this.propsData.goodsShowType) {
        case 1:
          return 'InterfaceOne';
        case 2:
          return 'InterfaceTwo';
        default:
          return 'InterfaceOne';
      }
    },
    imgActPadding: function imgActPadding() {
      var _this$propsData, _this$propsData2;
      if (!((_this$propsData = this.propsData) !== null && _this$propsData !== void 0 && _this$propsData.goodsPadding)) return;
      var _ref = ((_this$propsData2 = this.propsData) === null || _this$propsData2 === void 0 ? void 0 : _this$propsData2.goodsPadding) || {},
        pt = _ref.pt,
        pb = _ref.pb,
        pl = _ref.pl,
        pr = _ref.pr;
      return "".concat(pt || 0, "px ").concat(pr || 0, "px ").concat(pb || 0, "px ").concat(pl || 0, "px");
    }
  }
};